import React from "react";
import Brands1 from "../components/brands/Brands1";
import { FaLongArrowAltRight } from "react-icons/fa";
import BreadcrumbsHeader from "../components/breadcrumbs/BreadcrumbsHeader";

const InvestorRelations = () => {
  return (
    <div className="page-container">
      {/* Breadcrumbs Header */}
            <BreadcrumbsHeader 
        title="Investors Relations" 
        backgroundImage="/images/header/investor-relation.jpg" 
      />


      {/* About / Investor Section */}
      <section className="section-home-secondary" style={{ padding:'120px 0 115px'}}>
        <div className="b-home-about relative">
          <div className="vertical-container-top-mod vertical-left home-about-side-title hidden-md">
            <span className="vertical-text-main color-add text-uppercase">
              ISOLS Group
            </span>
            <span className="vertical-text-additional color-add-2 text-uppercase">
              IR
            </span>
          </div>

          <div className="container">
            <div className="row">
              {/* Left Text Column */}
              <div className="col-xs-12 col-sm-6">
                <div
                  className="b-mod-heading wow fadeInDown"
                  style={{ visibility: "visible", animationName: "fadeInDown" }}
                >
                  <p className="first-heading font-secondary">Invest With Us</p>
                  <h2 className="heading-line line-right customColor customPseudoElBg">
                    <strong>Together We Grow</strong>
                  </h2>
                </div>
                <div className="b-text">
                  <p>
                    When it comes to starting and nurturing a venture, it takes
                    a vision, knowledge and finance to create it, and to bring
                    next level innovation it requires dedication and hard work.
                    ISOLS Group of companies &amp; brands is a leading Technology
                    &amp; Digital Marketing corporation which has grown itself
                    sustainability in a short span of time, and is continuously
                    growing at a good pace with its great work. Though, the
                    company’s offshoot Innovative Solution Technologies was
                    founded domestically 6 years back as a small firm by the
                    young, versatile, visionary entrepreneur Dr. Ujjwal Chugh,
                    which has now grown into a complete large group having
                    various entities &amp; brands under it. The company has
                    started expanding globally as well. The company is being led
                    under the young &amp; dynamic leadership of the great digital
                    visionary Dr. Ujjwal Chugh (Founder &amp; CEO, ISOLS Group)
                    and being backed up at the admin level by the highly
                    spiritual, knowledgeable and experience rich personality Mr.
                    P.L. Chugh (Chairman, ISOLS Group). The company was earlier
                    in sole proprietorship but with all the efforts and hard work
                    of ISOLIANS under the leadership &amp; vision of the Founder
                    &amp; CEO, the company got incorporated into a private limited
                    entity, and then after one year company started its
                    international base in Canada. The promoters of the company;
                    Dr. Ujjwal Chugh and Mr. P.L Chugh are among some of the
                    most influential people of the society and are people
                    oriented personalities.
                  </p>
                </div>
              </div>

              {/* Right Image Column */}
              <div className="col-xs-12 col-sm-6 text-center">
                <div
                  className="img-brd-mod wow slideInRight"
                  style={{ visibility: "visible", animationName: "slideInRight" }}
                >
                  <div className="brd"></div>
                  <div className="img-cut">
                    <div className="cut"></div>
                    <img
                      src="/images/stoc454.jpg"
                      className="img-responsive center-block"
                      alt="Investor relation showing image"
                      aria-hidden="true"
                    />
                  </div>
                </div>
              </div>

              {/* Full Width Text */}
              <div className="col-xs-12 col-sm-12">
                <div className="b-text">
                  <p>
                    They believe in their team and for them great culture &amp;
                    like-minded team gives a birth to a great company. To grow
                    and propel a venture, it requires right leadership &amp;
                    vision; we have a team conviction and always look forward to
                    fulfil the vision and mission of our Group. We make sure
                    that we bring smiles on the faces of the people in need and
                    the ones who trust on us i.e. our clients.
                  </p>
                  <p>
                    We at ISOLS Group would like to invite wholeheartedly all
                    the investors who really want to grow bigger, interested in
                    making profits and wants to be a part of an influential
                    company. We respect &amp; appreciate like visionaries &amp;
                    minded investors; so that not only we should grow together
                    financially, but we should also do &amp; establish impactful
                    work &amp; assets which can act as a boon for the upcoming
                    generations.
                  </p>
                </div>
              </div>

              {/* Call to Action Button */}
              <div className="col-xs-12">
                <center>
                 <a href="/contact" className="btn btn-default-arrow btn-sm">
      <FaLongArrowAltRight className="icon" aria-hidden="true" />{" "}
      Make Investor Enquiry
    </a>
                </center>
              </div>
            </div>
          </div>
        </div>
      </section>
<Brands1 />
    </div>
  );
};

export default InvestorRelations;
